import { useFrame } from "@react-three/fiber";
import useStore from "../store";

export default function FrameTime() {
    const setFrameTime = useStore(state => state.setFrameTime)
    let frames = 0;
    let framesArray = [];
  useFrame((state, delta) => {
    if (frames > 181) return
    if (frames == 180) {
        let smoothDelta = 0;
        framesArray.map(item => {
            smoothDelta += item;
        })
        smoothDelta = smoothDelta / framesArray.length
        setFrameTime(smoothDelta)
    }
    if (frames <= 179) {
        framesArray.push(delta)
    }
    frames++;
  });
  return null;
}
